import { NETWORK } from '@shared/utils/constant'
import { LocalStorage } from '@injectivelabs/utils'
import { tokenStaticFactory } from '@shared/service'
import { tokens } from '@/app/json'
import type { TokenStatic } from '@injectivelabs/sdk-ts'

tokenStaticFactory.mapRegistry(tokens as TokenStatic[])

export const localStorage: LocalStorage = new LocalStorage(`mito-${NETWORK}-v6`)
